export default {
  namespaced: true,
  state: {
    globalMessages: [], // 全局消息通知
  },
  getters: {},
  mutations: {
    ADD_MESSAGE(state, globalMessages) {
      state.globalMessages.push(globalMessages);
    }
  },
  actions: { 
    receiveMessage({ commit }, globalMessages) {
      commit('ADD_MESSAGE', globalMessages);
    }
  }
}
